
import { useState } from "react";
import { CityPlacesDrawer } from "./CityPlacesDrawer";
import { DOT_COLOR_AVG } from "../Benchmark";
import { normalize } from "../../../../../../common/utils/TextUtils";

export const CityMarker = ({ lat, lng, city, places, keyword, competitor, allCompetitors }: any) => {
    
    let index = places?.findIndex((place: { title: string; }) => 
        normalize(place.title).includes(normalize(competitor))
    );
    
    const finalPosition = index !== -1 ? index + 1 : 21;

    const [panelVisible, setPanelVisible] = useState(false);
    const [cityPlacesDrawer, setCityPlacesDrawer] = useState(null);
    
    const handleMouseEnter = () => {
        setPanelVisible(true);                
    };
    
    const handleMouseLeave = () => {
        setPanelVisible(false);                
    };

    const onClick = () => {
        setCityPlacesDrawer(city);   
    }

    return (
        <>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={onClick} style={{ backgroundColor: DOT_COLOR_AVG[finalPosition], position:'absolute', zIndex: -1 * finalPosition, cursor: 'pointer', color:'white', height: '28px', width: '28px', borderRadius: '50%', border:'solid 2px white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <b>{finalPosition < 21 ? finalPosition : '+20'}</b>
            </div>
            {cityPlacesDrawer && <CityPlacesDrawer city={city} keyword={keyword} competitor={competitor} allCompetitors={allCompetitors} places={places} onFinish={() => {setCityPlacesDrawer(null)}} />}
        </>
    )
}
